<template lang="html">
  <div class="countctrl">
    
    <div class="btn btn-outline-primary btn-sm rounded-pill increase" @click.stop="increaseCount"><i class=" fas fa-xs fa-plus" ></i></div>
    <transition name="fade">
      <div class="count" v-if="cartItem && cartItem.quantity">{{cartItem.quantity}}</div>
    </transition>
    <transition name="fade">
      <div class="btn btn-outline-primary btn-sm rounded-pill decrease" v-if="cartItem && cartItem.quantity > 0"  @click.stop="decreaseCount"><i class=" fas fa-xs fa-minus" ></i></div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  props: {
    product: {
      type: Object,
    },
    cartItem: {
      type: Object,
    },
  },
  created: function () {},
  methods: {
    increaseCount: function () {
      if (!this.cartItem) {
        this.$store.dispatch("addToCart", this.product);
      } else {
        this.cartItem.quantity++;
        this.$store.dispatch("updateCartItem", this.cartItem);
      }
    },
    decreaseCount: function () {
      if (this.cartItem) {
        this.cartItem.quantity--;
        
        this.$store.dispatch("updateCartItem", this.cartItem);
      }
    },
  },
};
</script>

<style lang="css">
.countctrl {
  display: flex;
  align-items: center;
}
.countctrl .decrease,
.countctrl .count,
.countctrl .increase {
  display: inline-block;
  line-height: 1.3;
}
.countctrl .decrease,
.countctrl .count {
  transition: all 0.4s;
}
.countctrl .count.fade-enter,
.countctrl .count.fade-leave-active,
.countctrl .decrease.fade-enter,
.countctrl .decrease.fade-leave-active {
  opacity: 0;
}
.countctrl .count.fade-enter-active， .countctrl .decreate.fade-enter-active {
  opacity: 1;
}

.countctrl .decrease.fade-enter,
.countctrl .decrease.fade-leave-active {
  transform: translate3d(24px, 0, 0);
}
.countctrl .count {
  min-width: 1.4rem;
  color: rgb(147, 153, 159);
  text-align: center;
}
</style>
